import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../App';

function DataDeletion() {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    email: '',
    reason: '',
    confirm: false
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.confirm) return;
    setSubmitted(true);
    setFormData({ email: '', reason: '', confirm: false });
  };

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({ ...formData, [e.target.name]: value });
  };

  return (
    <div className="page-content">
      <Helmet>
        <title>Chefyz - {t.dataDeletion.title}</title>
        <meta name="description" content={t.dataDeletion.subtitle} />
        <meta property="og:title" content={`Chefyz - ${t.dataDeletion.title}`} />
        <meta property="og:description" content={t.dataDeletion.subtitle} />
      </Helmet>
      <div className="page-header">
        <div className="container">
          <h1>{t.dataDeletion.title}</h1>
          <p>{t.dataDeletion.subtitle}</p>
        </div>
      </div>

      <div className="page-body">
        <div className="container">
          <div className="deletion-content">
            <p className="deletion-intro">{t.dataDeletion.intro}</p>

            {/* Process Steps */}
            <div className="deletion-process">
              <h2>{t.dataDeletion.process.title}</h2>
              <div className="deletion-steps">
                <div className="deletion-step">
                  <span className="step-number">1</span>
                  <p>{t.dataDeletion.process.step1}</p>
                </div>
                <div className="deletion-step">
                  <span className="step-number">2</span>
                  <p>{t.dataDeletion.process.step2}</p>
                </div>
                <div className="deletion-step">
                  <span className="step-number">3</span>
                  <p>{t.dataDeletion.process.step3}</p>
                </div>
              </div>
            </div>

            {/* What Gets Deleted */}
            <div className="what-deleted">
              <h2>⚠️ {t.dataDeletion.what.title}</h2>
              <p>{t.dataDeletion.what.content}</p>
            </div>

            {/* Deletion Form */}
            <div className="deletion-form">
              <h2>🗑️ {t.dataDeletion.title}</h2>

              {submitted ? (
                <div className="form-success">
                  ✅ {t.dataDeletion.form.success}
                </div>
              ) : (
                <form
                  name="data-deletion"
                  method="POST"
                  data-netlify="true"
                  netlify-honeypot="bot-field"
                  onSubmit={handleSubmit}
                >
                  <input type="hidden" name="form-name" value="data-deletion" />
                  <p style={{ display: 'none' }}>
                    <label>Don't fill this out: <input name="bot-field" /></label>
                  </p>

                  <div className="form-group">
                    <label>{t.dataDeletion.form.email}</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      data-testid="deletion-email"
                    />
                  </div>

                  <div className="form-group">
                    <label>{t.dataDeletion.form.reason}</label>
                    <textarea
                      name="reason"
                      value={formData.reason}
                      onChange={handleChange}
                      rows="3"
                      data-testid="deletion-reason"
                    ></textarea>
                  </div>

                  <div className="checkbox-group">
                    <input
                      type="checkbox"
                      id="confirm"
                      name="confirm"
                      checked={formData.confirm}
                      onChange={handleChange}
                      required
                      data-testid="deletion-confirm"
                    />
                    <label htmlFor="confirm">{t.dataDeletion.form.confirm}</label>
                  </div>

                  <div className="form-submit">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={!formData.confirm}
                      style={{ opacity: formData.confirm ? 1 : 0.5 }}
                      data-testid="deletion-submit"
                    >
                      🗑️ {t.dataDeletion.form.submit}
                    </button>
                  </div>
                </form>
              )}

              <div className="deletion-note">
                ⚠️ {t.dataDeletion.note}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DataDeletion;
